const log_domain = "https://operation.betatechgroup.com";
const log_api = "/cikersapi/mcpod/record/inquirylog";

// 保存日志
function handleLog(data) {
  const appKey = "1465192825430740994";
  const appSecret = "65dbda572bc47eba9b584671e5753371";
  data["salesman"] = localStorage.getItem("salesman");
  data["currentPage"] = location.href;
  const params = JSON.stringify(data);
  const log_url = `${log_domain}${log_api}`;
  $.ajax({
    type: "POST",
    url: log_url,
    data: params,
    beforeSend: function (req) {
      req.setRequestHeader("appKey", appKey);
      req.setRequestHeader("appSecret", appSecret);
      req.setRequestHeader("Content-Type", "application/json");
    },
  });
}

function toCamelCase(str) {
  const reg = /[\/_-\s](\w)/g;
  return str
    .replace(reg, function (match, p1) {
      return p1.toUpperCase();
    })
    .replace(/^[A-Z]/, function (match) {
      return match.toLowerCase();
    });
}

function getFormdata(data) {
  const result = {};
  data.map((item) => {
    const camelname = toCamelCase(item.name);
    result[camelname] = item.value;
  });
  return result;
}

// 提交备份邮件
function handleBackup(form) {
  const formdata = $(form).serialize();
  const formarray = $(form).serializeArray();
  const params = getFormdata(formarray);
  handleLog(params);
  console.log("backupdata params===>", params);
  const backupdata = new FormData(form);
  backupdata.delete("_cc");
  const action = "https://formspree.io/f/mleqkzov";
  // 如果data 格式为原生formData,  jQuery 不能处理发送的数据 processData= false
  $.ajax({
    type: "POST",
    url: action,
    data: backupdata,
    async: false,
    cache: false,
    processData: false,
    contentType: false,
  });
}
